<template>
  <!-- pop-delete-block -->
  <div class="popup_in">
    <div class="popup pop-delete-block">
      <div class="popup_close">
        <a @click="$emit('close')"><CloseSvg /></a>
      </div>
      <div class="title bold">
        לתשומת ליבך
      </div>
      <div class="text let-1">
        מחיקת בלוק המרפאה הינה סופית <br />
        וללא יכולת שחזור
      </div>
      <div class="pop-delete-block-btns flex">
        <a
          class="bt_blue bt_border m-100"
          @click="$emit('close')"
          href="javascript:void(0);"
          >ביטול</a
        >
        <a
          class="bt_blue bt-approveDelete m-100"
          @click="confirmDelete"
          href="javascript:void(0)"
          >אישור מחיקה</a
        >
      </div>
    </div>
  </div>
  <!-- End pop-delete-block -->
</template>

<script>
import CloseSvg from "@/assets/img/svg/close-sm.svg";
import Error from "@/components/Popups/Error";

export default {
  name: "ConfirmDeleteBlock",
  props: ["block", "deleteAll"],
  data() {
    return {
      app_info: ""
    };
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("close");
      this.$router.go(-1);
    },
    confirmDelete() {
      let blocks_to_delete = [];
      blocks_to_delete.push({
        id: this.block.id,
        start: "",
        end: ""
      });
      if (this.deleteAll == "yes") {
        this.block.dup_blocks.map(dup_block => {
          let date = this.$moment(dup_block.start_date, "DD/MM/YYYY");
          let check_date = this.$moment(this.block.start_date, "DD/MM/YYYY");
          if (date.isAfter(check_date)) {
            blocks_to_delete.push({
              id: dup_block.block_id,
              start: "",
              end: ""
            });
          }
        });
      }
      this.$API
        .delete_block(blocks_to_delete)
        .then(res => {
          this.close();
        })
        .catch(e => {
          this.$modal.show(Error);
        });
    }
  },
  computed: {
    insurance() {
      let ins = [];
      let all_ob = this.block.appointments_ob;
      for (const key in all_ob) {
        if (ins.indexOf(all_ob[key].insurance) < 0) {
          ins.push(all_ob[key].insurance);
        }
      }
      return ins.join(",");
    }
  },
  components: { CloseSvg }
};
</script>

<style scoped></style>
